<template>
  <v-card rounded="xl" outlined :disabled="cardIsDisabled">
    <v-card-title>
      <v-row no-gutters class="">
        <v-col>
          <v-chip :color="status.color">{{ status.text }}</v-chip>
        </v-col>
        <v-col class="mt-3 pb-2" cols="12">
          <h5>Atendimento ambulatorial {{ tiposAtendimentos[atendimentoAmbulatorial.tipo] }}</h5>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pb-1">
      <p>
        <v-icon class="mr-1" size="20" color="primary">mdi-account-voice</v-icon>
        <strong>Teleatendimento</strong>
      </p>
      <p>
        <v-icon class="mr-1" size="20" color="primary">mdi-doctor</v-icon>
        <strong>Médico:</strong> {{ atendimentoAmbulatorial.medico_nome }}
      </p>
      <p @click="userCanEditHorario ? onEdit : ''">
        <v-icon class="mr-1" size="20" :color="userCanEditHorario ? 'primary' : '969697'">mdi-pencil</v-icon>
        <span class="link" :class="{ disable: !userCanEditHorario }">Alterar data do exame</span>
      </p>
      <p>
        <v-icon class="mr-1" size="20" color="primary">mdi-calendar</v-icon><strong>Data do Exame:</strong>
        {{ new Date(dataAgendamento).toLocaleDateString('pt-br') }}
      </p>
      <p>
        <v-icon class="mr-1" size="20" color="primary">mdi-clock-outline</v-icon><strong>Horário:</strong>
        {{ new Date(dataAgendamento).toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' }) }} (Horário de
        Brasília)
      </p>
    </v-card-text>
    <v-card-actions class="justify-space-between mx-2 mb-1">
      <v-btn @click="onCancel" color="primary" text small rounded disabled>
        Cancelar
      </v-btn>
      <AmbulatorialCardButton
        :dtAtendimento="new Date(dataAgendamento)"
        :idAtendimento="atendimentoAmbulatorial.id"
        :statusAtendimento="atendimentoAmbulatorial.status"
        :tipoAtendimento="atendimentoAmbulatorial.tipo"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { add, endOfDay, isAfter, isBefore } from 'date-fns'
import AmbulatorialCardButton from './AmbulatorialCardButton.vue'

export default {
  props: {
    atendimentoAmbulatorial: {
      type: Object,
      required: true
    }
  },
  components: {
    AmbulatorialCardButton
  },
  computed: {
    dataAgendamento() {
      return this.atendimentoAmbulatorial.horario || this.atendimentoAmbulatorial.dtcriacao
    },
    status() {
      return this.statusColors.find(item => this.atendimentoAmbulatorial.status === item.value)
    },
    userCanEditHorario() {
      const dataHoraExame = new Date(this.atendimentoAmbulatorial.horario)
      const dataHoraLimite = add(new Date(), { hours: 24 })
      return isBefore(dataHoraLimite, dataHoraExame)
    },
    cardIsDisabled() {
      if (this.atendimentoAmbulatorial.tipo === 'clinico') return true
      if (isAfter(new Date(), endOfDay(new Date(this.atendimentoAmbulatorial.horario)))) return true
      return ['finalizado', 'cancelado'].includes(this.atendimentoAmbulatorial.status)
    }
  },
  data() {
    return {
      tiposAtendimentos: {
        clinico: 'Clínico',
        nutricional: 'Nutricional',
        psicologico: 'Psicológico'
      },
      statusColors: [
        { text: 'Agendado', value: 'agendado', color: 'primary' },
        { text: 'Na fila', value: 'na_fila', color: 'primary' },
        { text: 'Finalizado', value: 'finalizado', color: 'success' },
        { text: 'Em atendimento', value: 'em_atendimento', color: 'purple' },
        { text: 'Ausente', value: 'ausente', color: '#a77f28' },
        { text: 'Entrada autorizada', value: 'entrada_permitida', color: 'info' }
      ]
    }
  },
  methods: {
    onCancel() {},
    onEdit() {
      this.$emit('on-edit', this.atendimentoAmbulatorial)
    }
  }
}
</script>

<style style="scoped">
.AgendamentoCard__border-dotted {
  border-bottom: 2px dotted #d6d6d6;
}

p {
  margin-bottom: 0.3em !important;
}

.btn-appointment {
  background-color: none !important;
  color: #006fee;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
  text-transform: unset !important;
  width: min-content !important;
  padding: 0px !important;
  font-size: 0.875rem !important;
  letter-spacing: unset !important;
}

.link {
  color: #055dff;
  text-decoration: underline;
  cursor: pointer;
}

.disable {
  color: #969697;
  cursor: not-allowed;
}
</style>
